var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBxRightArrowCircle = function SvgBxRightArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.667 1.025A6.675 6.675 0 001 7.693a6.674 6.674 0 006.667 6.666 6.675 6.675 0 006.667-6.666 6.675 6.675 0 00-6.667-6.668zm0 12.001a5.34 5.34 0 01-5.334-5.333 5.34 5.34 0 015.334-5.334A5.34 5.34 0 0113 7.693a5.34 5.34 0 01-5.334 5.333z",
    fill: "#D95437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.355H5.333v1.333H8v2.004l2.67-2.67L8 5.352v2.003z",
    fill: "#D95437"
  })));
};
export default SvgBxRightArrowCircle;